module.exports = __webpack_public_path__ + "img/la_board_v0.2eda4e80.png";